<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
      <div class="d-sm-flex align-items-center">
        <button @click="telecharger" v-if="valideEtape3" :disabled="isLoading"
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
          type="button">
          <i class="flaticon-download position-relative ms-5 fs-12"></i>
          <span v-if="!isLoading">Exporter</span>
          <span v-else>
            <span class="spinner-grow spinner-grow-sm me-2" role="status" aria-hidden="true"></span>
            Export en cours...
          </span>
        </button>
        <button
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-secondary fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
          type="button" v-if="!valideEtape3" disabled>
          <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
          <span class="visually-hidden">Chargement...</span>
        </button>
      </div>
      <div class="d-sm-flex align-items-center" v-if="checkPermission('AddUsager')">
        <a href="#" data-bs-toggle="modal"
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
          data-bs-target="#AddUsagerModal" @click="ajouterUsager" type="button">
          Nouvel usager
          <i class="flaticon-plus position-relative ms-5 fs-12"></i></a>
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-4 col-sm-12 col-lg-4 col-xl-4 col-xxl-4 col-xm-12">
        <div class="form-group mb-15 mb-sm-20 mb-md-25">
          <label class="d-block text-black fw-semibold mb-10"> Mot clé </label>
          <Field v-model="motCle" name="mot" type="text" aria-disabled="true"
            class="form-control shadow-none fs-md-15 text-black" placeholder="Recherche par mot clé" />
          <ErrorMessage name="mot" class="text-danger" />
        </div>
      </div>
      <div class="col-md-8 col-sm-12 col-lg-8 col-xl-8 col-xxl-8 col-xm-12">
        <div class="form-group mb-15 mb-sm-20 mb-md-25">
          <label class="d-block text-black fw-semibold mb-10">
            Etats
          </label>
          <Field name="etat" v-slot="{ field }" v-model="etat"
            class="form-control shadow-none fs-md-15 text-black">
            <Multiselect v-model="field.value" v-bind="field" mode="tags" :options="etatsOptions" :searchable="true"
              noResultText="Aucun enregistrement trouvé" placeholder="Rechercher par secteur" />
          </Field>
          <ErrorMessage name="secteur" class="text-danger" />
        </div>
      </div>
        </div>
      </div>
      <hr />
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                ###
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                #
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Nom complet
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                NPI
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                IFU
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Sexe
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Téléphone
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Catégorie
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Activité
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Détail
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(us, index) in usagers" :key="index">
              <td class="shadow-none lh-1 fw-medium text-primary">
                <a class="dropdown-item d-flex align-items-center" data-bs-toggle="modal"
                  @click="handleVoirImage(us.medias)" data-bs-target="#voirImageModal" style="cursor: pointer;">
                  <img v-if="(us.medias && us.medias.length > 0)"
                    :src="getUrlApiForFiles('Usagers', us.medias[(us.medias.length - 1)].nomMedia)" alt="PhotoUsager"
                    width="50" height="50" />
                </a>

              </td>
              <td class="shadow-none lh-1 fw-medium text-primary">
                {{ us.matricule }}
              </td>

              <td class="shadow-none lh-1 fw-medium text-primary">
                {{ us.full_name }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-primary">
                {{ us.npi }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-primary">
                {{ us.ifu }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-primary">
                {{ us.sexe }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ us.tel }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ afficher20Caracteres(us.activite) }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ afficher20Caracteres(us.new_activite) }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ afficher20Caracteres(us.nouveau_activite) }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-end pe-0 sm">
                <div class="dropdown">
                  <span class="badge text-white bg-secondary fs-15 dropdown-toggle" data-bs-toggle="dropdown"
                    aria-expanded="false">
                    Actions
                    <i class="flaticon-chevron-2 position-relative ms-5 top-2 fs-15"></i>
                  </span>
                  <ul class="dropdown-menu">
                    <li>
                      <router-link :to="`detail-usager/${us.matricule}`" type="button"
                        class="dropdown-item d-flex align-items-center">
                        <i class="flaticon-view lh-1 me-8 position-relative top-1"></i>
                        Détails
                      </router-link>
                    </li>
                    <li>
                      <a href="#" class="dropdown-item d-flex align-items-center" data-bs-toggle="modal"
                        data-bs-target="#AddUsagerModal" @click="modifUsager(us.matricule)" type="button"><i
                          class="flaticon-view lh-1 me-8 position-relative top-1"></i>
                        Modifier
                      </a>
                    </li>
                    <li>
                      <a @click="getApercu(us)" type="button" class="dropdown-item d-flex align-items-center">
                        <i class="flaticon-send lh-1 me-8 position-relative top-1"></i>
                        Apercu du statut
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
        <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit"
          @paginate="handlePaginate" />
      </div>
    </div>
  </div>
  <div class="modal fade" id="imageModal" tabindex="-1" aria-labelledby="imageModalLabel" aria-hidden="true"
    ref="modalEl">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="imageModalLabel">Aperçu de l'image</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Fermer"></button>
        </div>
        <div class="modal-body d-flex justify-content-center align-items-center" style="min-height: 300px;">
          <img :src="currentImageUrl" alt="Image" class="img-fluid" />
        </div>
      </div>
    </div>
  </div>
  <AddUsagerModal :item="selectedItem" @close="recharger" @open="show_Modal" />

  <div class="modal fade" id="voirImageModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-hidden="true" ref="voirImageModal">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5">Voir image</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body d-flex justify-content-center align-items-center">
          <img v-if="currentImageUrl" :src="currentImageUrl" alt="PhotoUsager" />
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
            Fermer
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { ref, defineComponent, onMounted, watch } from "vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import AddUsagerModal from "./Usager.vue";
import {
  showModal,
  suppression,
  separateur,
  format_Date,
  format_date,
  supprimerElement,
  error,
  checkPermission,
  dateActuelle,
  success,
  getUrlApiForFiles,
  afficher20Caracteres,
  downloadExcel,
} from "@/utils/utils";
import { Contrat } from "@/models/Contrat";
import ApiService from "@/services/ApiService";
import { Option } from "@/models/Option";
import PaginationComponent from "@/components/Utilities/Pagination.vue";
import JwtService from "@/services/JwtService";
import Multiselect from "@vueform/multiselect";
import axios from "axios";
import Swal from "sweetalert2";
import bootstrap from "bootstrap";

export default defineComponent({
  name: "ListeUsager",
  components: {
    PaginationComponent,
    Field,
    ErrorMessage,
    AddUsagerModal,
    Multiselect
  },
  setup: () => {
    // BEGIN PAGINATE
    const searchTerm = ref("");
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);
    const secteursOptions = ref<Array<Option>>([]);
    const motCle = ref("");
    const dateFin = ref(dateActuelle());
    const dateDebut = ref(dateActuelle());
    const lemontant = ref("0");
    const donn = ref();
    const selectedItem = ref();
    const etat = ref([3]);
    const etatsOptions = ref<Array<any>>([
      { value: "1", label: "A jour" },
      { value: "2", label: "Non a jour" },
      { value: "3", label: "Tous" },
      { value: "4", label: "A au moins une place" },
      { value: "5", label: "A plus d'une place" },
      { value: "6", label: "Aucune place" },
      { value: "7", label: "A une image" },
      { value: "8", label: "A n'a aucune image" },
      { value: "9", label: "A un NPI" },
      { value: "10", label: "N'a pas de NPI" },
      { value: "11", label: "A un IFU" },
      { value: "12", label: "N'a pas d'IFU" },
      { value: "13", label: "A une date de naissance" },
      { value: "14", label: "N'a pas de date de naissance" },
      { value: "15", label: "A un sexe" },
      { value: "16", label: "N'a pas de sexe" },
      { value: "17", label: "A un telephone" },
      { value: "18", label: "N'a pas de telephone" },
      { value: "19", label: "A une adresse" },
      { value: "20", label: "N'a pas d'adresse" },
    ]);
    const show_Modal = (el) => {
      showModal(el);
      selectedItem.value = 0;
    };

    const ajouterUsager = () => {
      selectedItem.value = null;
    };

    const modifUsager = (usager) => {
      selectedItem.value = usager;
    };
    // END PAGINATE
    const handlePaginate = ({ page_, limit_ }) => {
      try {
        page.value = page_;
        limit.value = limit_;
        actionRecherche(page_, limit_);
      } catch (error) {
        //
      }
    };

    const valideEtape3 = ref(true);
    const isLoading = ref(false);
    const recharger = () => {
      actionRecherche(page.value, limit.value);
    };
    const agent = ref();
    const agentOptions = ref();
    const usagers: any = ref<Array<any>>([]);

    const openAndPrint = (url: string) => {
      const newWindow = window.open(url, "_blank");

      if (newWindow) {
        newWindow.onload = () => {
          newWindow.print();
        };
      } else {
        console.error("Impossible d'ouvrir la fenêtre");
      }
    };
    function openNewWindow(data: any, dossier = "Recu") {
      openAndPrint(getUrlApiForFiles(dossier, data.reference + ".pdf"));
    }
    const actionRecherche = async (pageParam = 1, limi = 10, searchTerm = "") => {
      const element = {
        motCle: motCle.value,
        page: page.value,
        totalPages: totalPages.value,
        limit: limit.value,
        totalElements: totalElements.value,
        mot: searchTerm,
        etat: etat.value,
      };
      donn.value = element;
      try {
        const response = await axios.post("listeUsagers", element);
        usagers.value = response.data.data.data.entities;
        totalPages.value = response.data.data.totalPages;
        limit.value = response.data.data.limit;
        totalElements.value = response.data.data.totalElements;
      } catch (err) {
        // error("Erreur");
      }
    };

    const getPoint = async () => {
      try {
        valideEtape3.value = false;
        donn.value = {
          dateDebut:
            (dateDebut.value ? dateDebut.value : dateActuelle()) + " 00:00:00",
          dateFin:
            (dateFin.value ? dateFin.value : dateActuelle()) + " 23:59:59",
          motCle: motCle.value,
          acteur: agent.value,
        };
        const response = await axios.post("/getPoint", donn.value);
        openNewWindow({ reference: response.data.data });
        valideEtape3.value = true;
      } catch (error) {
        // error("Erreur");
      }
    };

    const getApercu = async (value: any) => {
      try {
        if (value) {
          const response = await axios.post("/getPointUsager", value);
          if ((response).status == 201) {
            openNewWindow({ reference: response.data.data }, "PointUsager");
          }
        }
      } catch (err) {
        if (axios.isAxiosError(err) && err.response) {
          error(err.response.data.message || err.message);
        } else {
          if (err instanceof Error) {
            error(err.message);
          } else {
            error(String(err));
          }
        }
      }

    }

    const telecharger = async () => {
      valideEtape3.value = false;
      isLoading.value = true;
      try {
        const element = {
          motCle: motCle.value,
          etat: etat.value,
        };
        const response = await axios.post("/liste/usagers/export", element);
        const downloadUrl = await getUrlApiForFiles("Excel", response.data.data + ".xlsx");

        await downloadExcel(downloadUrl);
        openAndPrint(getUrlApiForFiles("Excel", response.data.data + ".xlsx"));
        valideEtape3.value = true;
      } catch (err) {
        if (axios.isAxiosError(err) && err.response) {
          error(err.response.data.message || err.message);
        } else {
          if (err instanceof Error) {
            error(err.message);
          } else {
            error(String(err));
          }
        }
        valideEtape3.value = true;
      } finally {
        isLoading.value = false;
      }
    };
    watch(motCle, (newValue, oldValue) => {
      page.value = 1;
      limit.value = 10;
      totalPages.value = 0;
      totalElements.value = 0;
      motCle.value = newValue;
      actionRecherche(page.value, limit.value);
    });

     watch(etat, (newValue, oldValue) => {
      page.value = 1;
      limit.value = 10;
      totalPages.value = 0;
      totalElements.value = 0;
      etat.value = newValue;
      actionRecherche(page.value, limit.value);
    });
    const supprime = async (id) => {
      Swal.fire({
        text: `Vous êtes sur le point de supprimer le retour n° ${id}. Etes-vous sûr ?`,
        icon: "warning",
        buttonsStyling: true,
        showCancelButton: true,
        confirmButtonText: "Supprimer",
        cancelButtonText: `Annuler`,
        heightAuto: false,
        customClass: {
          confirmButton: "btn btn-danger",
        },
      })
        .then(async (result) => {
          if (result.isConfirmed) {
            await ApiService.delete(`delete/usager/${id}`)
              .then(async ({ data }) => {
                if (data.code == 200) {
                  success(data.message);
                  await actionRecherche(1, 10);
                }
              })
              .catch(async ({ response }) => {
                error(response.message);
              });
          }
        })
        .catch(async ({ response }) => {
          error(response.message);
        });
    };
    const currentImageUrl = ref('')

    // Cette fonction est appelée au clic
    function handleVoirImage(medias) {
      if (medias && medias.length > 0) {
        const lastMedia = medias[medias.length - 1]
        currentImageUrl.value = getUrlApiForFiles('Usagers', lastMedia.nomMedia)
      }
    }

    onMounted(async () => {
      await actionRecherche(1, 10);
    });
    return {
      handleVoirImage,
      currentImageUrl,
      dateDebut,
      dateFin,
      suppression,
      recharger,
      page,
      agentOptions,
      agent,
      openNewWindow,
      usagers,
      secteursOptions,
      totalPages,
      limit,
      format_date,
      format_Date,
      separateur,
      totalElements,
      handlePaginate,
      searchTerm,
      motCle,
      error,
      lemontant,
      getPoint,
      valideEtape3,
      isLoading,
      selectedItem,
      afficher20Caracteres,
      show_Modal,
      ajouterUsager,
      modifUsager,
      dateActuelle,
      getUrlApiForFiles,
      supprime,
      getApercu,
      telecharger,
      etat,
      etatsOptions,
      checkPermission,
    };
  },
});
</script>